import React, { useState, useEffect } from "react";
import { sendToAndroid } from "../services/androidBridge";
import {transferListLanguageOptions} from "./dropdown/dropdown-data";
import {fuelConst} from "../utils/fuelConstants";

const Event = ({event, onBack}) => {
  const [selectedAccount, setSelectedAccount] = useState("");
  const [accountList, setAccountList] = useState([]);

  const [confirmMessage, setConfirmMessage] = useState("notLoaded");
  const [successMessage, setSuccessMessage] = useState("notLoaded");
  const [jwt, setJwt] = useState();
  const [userName, setUserName] = useState("");

  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [closeLoading, setCloseLoading] = useState(false);
  const [title, setTitle] = useState();
  const [warning] = useState("");
  const [onConfirm, setOnConfirm] = useState("");
  const [transferRequest, setTransferRequest] = useState("");
  const [, setExtractedUrl] = useState("");
    const [bookingFor, setBookingFor] = useState("self");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [fullName, setFullName] = useState("");
    const [pnr, setPnr] = useState(null);
  const [isFirst, setIsFirst] = useState(true);
  const [ticket, setTicket] = useState(null);


  const handleAccountChange = (e) => {
    setSelectedAccount(e.target.value);
  };

  const handleTicketChange = (e) => {
    const selectedId = e.target.value;

    if (!selectedId) {
      setTicket(null);
      return;
    }

    const ticketObject = event.tickets.find(
        (t) => t.id === parseInt(selectedId, 10)
    );

    setTicket(ticketObject);
  };

  const handleFirstRender = (request) => {
    if (!isFirst) {
      sendDataToAndroid(request);
    }
    setIsFirst(false);
  };

  useEffect(() => {
    sendDataToAndroid("first");

    window.receiveDataFromAndroid = (data) => {
      var dataString = JSON.stringify(data);
      var obj = JSON.parse(dataString);

      if (JSON.parse(obj.request).name === "accountList") {
        if (
            obj.response !== undefined &&
            JSON.parse(obj.response).data !== undefined
        ) {
          let uniqueAccountList = [];
          JSON.parse(JSON.parse(obj.response).data).forEach((account) => {
            uniqueAccountList = [
              ...uniqueAccountList,
              { label: account.accounts, value: account.accounts },
            ];
            setAccountList([...uniqueAccountList]);
          });
        }
      }

      if (JSON.parse(obj.request).name === "confirmResponse") {
        setOnConfirm("true");
      }

      if (JSON.parse(obj.request).name === "jwt") {
        setJwt(JSON.parse(obj.response).data);
      }

      if (JSON.parse(obj.request).name === "response") {
        const urlFromResponse = JSON.parse(obj.request).url;
        setExtractedUrl(urlFromResponse);

        handleDataBasedOnUrl(urlFromResponse, JSON.parse(obj.response).data);
      }

      if (JSON.parse(obj.request).name === "userName") {
        setUserName(JSON.parse(obj.response).data);
      }
    };
  }, []);

  const handleDataBasedOnUrl = (url, responseData) => {
    console.log("method called " + url);
    if (url.includes("eventApp/services/bookingOther")) {
      setLoading(false);
      const { data, status, desc } = JSON.parse(responseData);
      console.log("booking other log  " + JSON.stringify(data));
      if (status === true) {
        const { payload } = data;
        setPnr(payload.bookingCode)
      } else {
        setErrorMessage(desc);
        setSuccessMessage("");
      }
    }else if (url.includes("eventApp/services/payEventPayment")) {
      setLoading(false);
      const { data, status, desc } = JSON.parse(responseData);
      if (status === true) {
        setSuccessMessage(`Ticket purchase of ${data.payload.price} Birr for event "${data.payload.eventName}" (${data.payload.ticketName}) has been completed. Your PNR is ${data.payload.bookingCode}. Please use the link in the confirmation SMS to download your QR Code ticket.`);
      } else {
        setErrorMessage(desc);
        setSuccessMessage("");
      }
    }
  };
  useEffect(() => {
    if (!isFirst) {
      setTitle(transferListLanguageOptions[jwt][7]);
    }
    setIsFirst(false);
  }, [jwt]);
  useEffect(() => {
    handleFirstRender("title");
  }, [title]);

  useEffect(() => {
    handleFirstRender("confirm");
  }, [confirmMessage]);
  useEffect(() => {
    handleFirstRender("success");
  }, [successMessage]);

  useEffect(() => {
    handleFirstRender("warning");
  }, [errorMessage]);

  useEffect(() => {
    handleFirstRender("openLoading");
  }, [loading]);

  useEffect(() => {
    handleFirstRender("openLoading");
    if (closeLoading) {
      setLoading(false);
      setCloseLoading(false);
    }
  }, [closeLoading]);

  useEffect(() => {
    handleFirstRender("warning");
  }, [warning]);

  useEffect(() => {
    if (onConfirm !== "") {
      handleFirstRender("request");
    }
  }, [onConfirm]);

  function formateventDate(isoDate) {
    const date = new Date(isoDate);

    const formattedDate = date.toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true
    });

    return formattedDate;
  }

  const sendDataToAndroid = (name) => {
    var transferData = {
      transferData: [],
    };
    if (name === "return") {
      transferData = {
        transferData: [
          {
            type: "return",
            request: { name: "graphData" },
            response: {},
            name: "",
          },
        ],
      };
    } else if (name === "title") {
      transferData = {
        transferData: [
          {
            type: "title",
            request: { name: "title" },
            response: { data: title },
            name: "",
          },
        ],
      };
    } else if (name === "first") {
      transferData = {
        transferData: [
          {
            type: "first",
            request: { name: "first" },
            response: {},
            name: "",
          },
        ],
      };
    } else if (name === "confirm") {
      transferData = {
        transferData: [
          {
            type: "confirm",
            request: { name: "confirm" },
            response: { data: confirmMessage },
            name: "",
          },
        ],
      };
    } else if (name === "openLoading") {
      transferData = {
        transferData: [
          {
            type: "openLoading",
            request: { name: "openLoading" },
            response: { data: loading },
            name: "",
          },
        ],
      };
    } else if (name === "closeLoading") {
      transferData = {
        transferData: [
          {
            type: "closeLoading",
            request: { name: "closeLoading" },
            response: { data: closeLoading },
            name: "",
          },
        ],
      };
    } else if (name === "warning") {
      transferData = {
        transferData: [
          {
            type: "warning",
            request: { name: "warning" },
            response: { data: errorMessage },
            name: "",
          },
        ],
      };
    } else if (name === "error") {
      transferData = {
        transferData: [
          {
            type: "error",
            request: { name: "error" },
            response: { data: errorMessage },
            name: "",
          },
        ],
      };
    }else if (name === "success") {
      transferData = {
        transferData: [
          {
            type: "success",
            request: { name: "success" },
            response: { data: successMessage },
            name: "",
          },
        ],
      };
    }else if (name === "bookTicket") {
      console.log(ticket)
      transferData = {
        transferData: [
          {
            type: "requestPost",
            request: { name: "eventApp/services/bookingOther" },
            response: { data:{
                ticketId: ticket.id,
                bookedBy:userName,
                phoneNumber: phoneNumber,
                fullName: bookingFor === "other" ? fullName : userName,
                channel:"OMNI"
              }
              },
            name: "",
          },
        ],
      };
    }
    else if (name === "request") {
      transferData = {
        transferData: [
          {
            type: "requestPost",
            request: { name: "eventApp/services/payEventPayment" },
            response: { data: JSON.stringify(transferRequest)
            },
            name: "",
          },
        ],
      };
    }
    sendToAndroid(transferData);
    setConfirmMessage("");
    setOnConfirm("");
    setErrorMessage("");
  };


  const handleBooking = () => {
      setLoading(true);
      sendDataToAndroid("bookTicket");
    };

    const handlePayment = () => {
      if (!pnr) return;
      setLoading(true);
      const message =
          `<b>Ticket Purchase for Event:</b> ${ticket.eventName} <br><br>` +
          `<b>Ticket: </b> ${ticket.ticketName} <br><br>` +
          `<b>Amount: </b> ${ticket.price} <br><br>` +
          `<b>PNR</b> ${pnr} <br><br>`;

      setTransferRequest({
        branchCode: "1",
        branchName: "HQ",
        userId: "omni",
        fromAccount: selectedAccount,
        fromName: userName,
        paymentReference: pnr
      });
      setConfirmMessage(message);
    };

    return (
        // <ComingSoon/>
        <div className="service-screen w-full max-w-md mx-auto p-4">
          <button
              onClick={onBack}
              type="primary"
              className="mb-2 px-4 py-2 rounded-lg shadow hover:bg-gray-100 transition flex items-center"
          >
            <svg
                className="w-4 h-4 mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
            >
              <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
            Back to events
          </button>

          <div className="mb-4">
            <label className="block mb-1 font-medium text-gray-700">
              {fuelConst[jwt]?.labels[0]}
            </label>
            <select
                value={selectedAccount}
                onChange={handleAccountChange}
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
            >
              <option key={0} value={"choose"}>
                {fuelConst[jwt]?.labels[0]}
              </option>
              {accountList.map((s) => (
                  <option key={s.id} value={s.value}>
                    {s.value}
                  </option>
              ))}
            </select>
          </div>

          <h1 className="text-2xl font-bold mb-2">{event.eventName}</h1>
          <p className="text-gray-600">{event.location}</p>
          <p className="text-gray-600">{formateventDate(event.eventDate)}</p>
          <p className="mt-2">{event.description}</p>

          <div className="mt-4">
            <label className="block mb-1 font-medium">Select Ticket Type</label>
            <select
                value={ticket ? ticket.id : ''}
                onChange={handleTicketChange}
                className="border rounded w-full px-3 py-2"
            >
              <option value="">-- Choose --</option>
              {event.tickets.map((t) => (
                  <option key={t.id} value={t.id}>
                    {t.ticketName} - {t.price} Birr
                  </option>
              ))}
            </select>
          </div>

          <div className="mt-4">
            <label className="block mb-1 font-medium">Booking For</label>
            <div className="flex gap-4">
              <label className="flex items-center gap-2">
                <input
                    type="radio"
                    name="bookingFor"
                    value="self"
                    checked={bookingFor === "self"}
                    onChange={() => setBookingFor("self")}
                />
                Self
              </label>
              <label className="flex items-center gap-2">
                <input
                    type="radio"
                    name="bookingFor"
                    value="other"
                    checked={bookingFor === "other"}
                    onChange={() => setBookingFor("other")}
                />
                Other
              </label>
            </div>
          </div>

          {bookingFor === "other" && (
              <div className="mt-4">
                <label className="block mb-1 font-medium">Full Name</label>
                <input
                    type="text"
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                    className="border rounded w-full px-3 py-2"
                    placeholder="Full name of attendee"
                />
              </div>
          )}

          <div className="mt-4">
            <label className="block mb-1 font-medium">Phone Number</label>
            <input
                type="tel"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                className="border rounded w-full px-3 py-2"
                placeholder="Phone number"
            />
          </div>
          {pnr && <p className="mt-4 text-center">Booking successful with pnr: {pnr}</p>}

          {!pnr ? (
              <button
                  onClick={handleBooking}
                  disabled={
                      selectedAccount==="" ||
                      !ticket ||
                      !phoneNumber ||
                      !phoneNumber.match(/^09|07[0-9]{8}$/) ||
                      (bookingFor === "other" && !fullName) ||
                      loading
                  }
                  className={`w-full py-2 mt-4 rounded text-white font-semibold ${
                      selectedAccount==="" ||
                      !ticket ||
                      !phoneNumber ||
                      !phoneNumber.match(/^09|07[0-9]{8}$/) ||
                      (bookingFor === "other" && !fullName) ||
                      loading
                          ? "bg-gray-400 cursor-not-allowed"
                          : "bg-green-600 hover:bg-green-700"
                  }`}
              >
                {loading ? "Booking..." : "Book Now"}
              </button>

          ) : (
              <button
                  onClick={handlePayment}
                  disabled={loading}
                  className={`w-full py-2 mt-4 rounded text-white font-semibold ${
                      loading
                          ? "bg-gray-400 cursor-not-allowed"
                          : "bg-blue-600 hover:bg-blue-700"
                  }`}
              >
                {loading ? "Processing Payment..." : "Pay Now"}
              </button>
          )}
        </div>
    );
  };

  export default Event;
